import { afterNextRender, Component, computed, ElementRef, inject, OnDestroy, viewChild } from '@angular/core';
import { KeenSliderInstance } from 'keen-slider';
import KeenSlider from 'keen-slider';
import { SignalsStoreService } from '../signals-store.service';
import { RouterModule } from '@angular/router';
import { GlobalMessageService } from './global-message.service';
import { delay, map, tap } from 'rxjs';

@Component({
    selector: 'app-global-message',
    imports: [
        RouterModule
    ],
    templateUrl: './global-message.component.html',
    styleUrl: './global-message.component.scss'
})
export class GlobalMessageComponent implements OnDestroy {

  //#region Services

  #signalsStorageService = inject(SignalsStoreService);
  #signalStoreService = inject(SignalsStoreService);
  #globalMessageService = inject(GlobalMessageService);

  //#endregion

  //#region Properties

  messageSlider = viewChild<ElementRef>('messageSlider');

  slider!: KeenSliderInstance;

  messages = computed(() => this.#signalsStorageService.globalMessages());

  //#endregion

  //#region Constructors

  constructor() {
    afterNextRender(() => {
      this.#getGlobalMessages();
    })
  }

  ngOnDestroy(): void {
    if (this.slider) this.slider.destroy();
  }

  //#endregion

  //#region Methods

  #setUpSlide(loop: boolean) {

    try {

      this.slider = new KeenSlider(this.messageSlider()?.nativeElement, {
        initial: 0,
        renderMode: 'performance',
        loop,
        drag: false,
        vertical: true
      }, [
        (slider) => {
          let timeout: NodeJS.Timeout | null = null;
          let mouseOver = false
          function clearNextTimeout() {
            if (timeout)
              clearTimeout(timeout);
          }
          function nextTimeout() {

            if (timeout)
              clearTimeout(timeout);

            if (mouseOver) return
            timeout = setTimeout(() => {
              slider.next()
            }, 1000 * 5)
          }
          slider.on("created", () => {
            slider.container.addEventListener("mouseover", () => {
              mouseOver = true
              clearNextTimeout()
            })
            slider.container.addEventListener("mouseout", () => {
              mouseOver = false
              nextTimeout()
            })
            nextTimeout()
          })
          slider.on("dragStarted", clearNextTimeout)
          slider.on("animationEnded", nextTimeout)
          slider.on("updated", nextTimeout)
        }
      ]);

    } catch (error) {
      console.log('error', error);
    }
  }

  #getGlobalMessages() {

    this.#signalStoreService.globalMessages.set([]);

    this.#globalMessageService
      .getGlobalMessage()
      .pipe(
        map(res => {
          return (res ?? []).filter(x => this.#signalStoreService.hasSession() ? x.visibleWithSesion : x.visibleWithoutSesion);
        }),
        tap(res => this.#signalStoreService.globalMessages.set(res)),
        delay(1500),
        tap(res => {
          if (res.length) this.#setUpSlide(res.length > 1);
        })
      )
      .subscribe();
  }

  //#endregion
}
